import { defineMessages } from 'react-intl';

export const i18n: {
	comments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	owner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	generatingReport: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	generatingContentPropertiesReport: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labels: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modified: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reactions: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	title: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	unresolvedComments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	comments: {
		id: 'page-properties-report-renderer.table.comments',
		defaultMessage: 'Comments',
		description: 'Table header for the count of comments column',
	},
	owner: {
		id: 'page-properties-report-renderer.table.owner',
		defaultMessage: 'Owner',
		description:
			'The text is shown as the column header in the page properties report table identifying the column that displays the owner or author of each listed page.',
	},
	errorMessage: {
		id: 'page-properties-report-renderer.error.message',
		defaultMessage: 'Unable to display this report. Refresh and try again.',
		description:
			"Instruction message letting the user know we couldn't display the report, and to refresh in order to try again.",
	},
	generatingReport: {
		id: 'page-properties-report-renderer.loading.message',
		defaultMessage: 'Generating Page Properties Report...',
		description: 'Loading text to inform user that the report is being generated',
	},
	generatingContentPropertiesReport: {
		id: 'page-properties-report-renderer.loading.message.content-properties',
		defaultMessage: 'Generating content properties report...',
		description:
			'Loading text to inform user that the report is being generated, updated to reflect new macro name (Content properties report) for both live docs & pages',
	},
	labels: {
		id: 'page-properties-report-renderer.table.labels',
		defaultMessage: 'Labels',
		description:
			'The text is shown as the column header in the page properties report table identifying the column that displays the labels assigned to each listed page.',
	},
	modified: {
		id: 'page-properties-report-renderer.table.modified',
		defaultMessage: 'Modified',
		description: 'Table header for the last date modified column',
	},
	noContent: {
		id: 'page-properties-report-renderer.noContent',
		defaultMessage: 'No content found',
		description: 'Message shown to user when their table has no content found',
	},
	reactions: {
		id: 'page-properties-report-renderer.table.reactions',
		description:
			'The text is shown as the column header in the page properties report table identifying the column that displays emoji reactions associated with each listed page.',
		defaultMessage: 'Reactions',
	},
	title: {
		id: 'page-properties-report-renderer.table.title',
		description: 'Table column header for page title column',
		defaultMessage: 'Title',
	},
	unresolvedComments: {
		id: 'page-properties-report-renderer.table.unresolvedComments',
		defaultMessage: 'Unresolved comments',
		description: 'Table header for the comments count column',
	},
});
